export type BcraReportStatus = 'not-started' | 'incomplete' | 'pending' | 'ready' | 'error';

export type BreastDensity = 'Dense' | 'Not Dense' | 'Unknown';

export interface BcraResult {
  /** Gail model absolute risk (summary[0].AbsRisk), in percent. */
  lifetimeRisk: number;
  /** Model's U.S. average for the same age and race/ethnicity (summary[0].AbsRisk_Avg), in percent. */
  averageRisk: number;
  /** From requestData.personalHealthHistory.breastDensity. */
  breastDensity: BreastDensity;
  /** When the questionnaire was submitted (requestData.createdAt). */
  answeredAt: Date | null;
}

export interface BcraReport {
  status: BcraReportStatus;
  /** Only present once the report is ready. */
  result: BcraResult | null;
}

export interface BcraStatusContent {
  title: string;
  body: string;
  showReviewSurvey: boolean;
  showReportIssue: boolean;
  /** Call-to-action button below the card, if any; `quizPath` is relative to the breast health quiz. */
  cta: { label: string; quizPath: string } | null;
}

/** Shared by the report page and the PDF. */
export const SCREENING_FACTORS: readonly string[] = [
  'Your age',
  'Your breast density',
  'Previous breast conditions or biopsies',
  'Genetic test results',
  'A history of radiation therapy to the chest',
  'Changes in your personal or family cancer history',
  'Previous mammogram or imaging results',
];

export type FaqBlock =
  | { type: 'text'; text: string }
  | { type: 'link'; text: string; href: string };

export interface FaqItem {
  question: string;
  answer: FaqBlock[];
}
